import React, { createContext, useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import { getContactMessages, deleteContactMessage } from '../services/api';

export const ContactMessageContext = createContext();

export const ContactMessageProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchMessages = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getContactMessages();
      setMessages(response.data);
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'خطا در دریافت پیام‌ها';
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  }, []);

  const removeMessage = useCallback(async (id) => {
    setLoading(true);
    setError(null);
    try {
      await deleteContactMessage(id);
      setMessages((prev) => prev.filter((msg) => msg.id !== id));
      toast.success('پیام با موفقیت حذف شد');
    } catch (err) {
      const errorMessage =
        err.response?.status === 404
          ? 'پیام مورد نظر یافت نشد'
          : err.response?.data?.message || 'خطا در حذف پیام';
      setError(errorMessage);
      toast.error(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <ContactMessageContext.Provider
      value={{
        messages,
        loading,
        error,
        fetchMessages,
        removeMessage,
      }}
    >
      {children}
    </ContactMessageContext.Provider>
  );
};